module.exports = __webpack_public_path__ + "static/img/supportbear.ae7fb86.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/support/images/supportbear.png
// module id = T/p7
// module chunks = 8